module.exports = __webpack_public_path__ + "static/happy_thank_you-f3652e6b9c57d78db727ed2e9d461354.svg";